import { useState, useEffect } from 'react'
import { TOP_NAV_HEIGHT_PX } from '~/common/scrollUtils'
import { Box, Portal } from '~/design_system'
import { $thm } from '~/common/themeSx'
import { Thread } from '../Thread'

type AssistantDrawerProps = {
  isOpen: boolean
  onClose: () => void
}

export const AssistantDrawer = ({ isOpen, onClose }: AssistantDrawerProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const body = document.body

    if (isOpen) {
      body.classList.add('assistant-open')
    } else {
      body.classList.remove('assistant-open')
    }

    return () => {
      body.classList.remove('assistant-open')
    }
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  return (
    <Portal>
      <Box
        position="fixed"
        top={TOP_NAV_HEIGHT_PX}
        left={isExpanded ? 0 : undefined}
        right={0}
        bottom={0}
        width={isExpanded ? 'auto' : '390px'}
        borderTop="1px solid"
        borderLeft="1px solid"
        sx={$thm({
          bg: { $base: 'white', $canvas: 'system.color.bg.default' },
          borderColor: { $base: 'gray.200', $canvas: 'system.color.border.divider' },
          boxShadow: { $base: 'none', $canvas: '5' }
        })}
        zIndex="docked"
        pointerEvents="auto"
        display="flex"
        flexDirection="column">
        <Thread onClose={onClose} isExpanded={isExpanded} onToggleExpand={() => setIsExpanded(prev => !prev)} />
      </Box>
    </Portal>
  )
}
